import axios from '~/utils/axios';
import { MambuConfiguration, MambuStatus } from '~/types';

export const getMambuLedgerStatus = () => {
  return axios.get<MambuStatus>(`/ledgers/mambu/status`).then((res) => res.data);
};

export const getMambuLedgerConfiguration = () => {
  return axios.get<MambuConfiguration>(`/ledgers/mambu/configuration`).then((res) => res.data);
};

export const setMambuLedgerConfiguration = (params: MambuConfiguration) => {
  return axios
    .put<MambuConfiguration>(`/ledgers/mambu/configuration`, params)
    .then((res) => res.data);
};
